import { render, staticRenderFns } from "./BlockBox.vue?vue&type=template&id=fea9ccd4"
import script from "./BlockBox.vue?vue&type=script&lang=js"
export * from "./BlockBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports